<template>
  <div class="msgDetails">
    <div class="zMsgSearch">
      <span>{{ $t("common.dataType") }}</span>
      <el-select
        v-model="selectType"
        style="width: 120px"
        :placeholder="$t('common.choseTip')"
      >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.dictValue"
          :value="item.id"
        />
      </el-select>
      <span>{{ $t("common.date") }}</span>
      <el-date-picker
        size="small"
        v-model="DataValue"
        type="datetimerange"
        :clearable="false"
        value-format="yyyy-MM-dd HH:mm:ss"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
      >
      </el-date-picker>
      <el-button
        style="margin-left: 18px"
        @click="onSearch"
        size="small"
        type="primary"
        class="btn-chaxun"
        >{{ $t("common.btn.search") }}</el-button
      >
      <el-button @click="onClear" size="small" class="btn-del">{{
        $t("common.btn.cancel")
      }}</el-button>
    </div>
    <div class="zMsgTable">
      <linegraph
        v-if="isValue"
        v-loading="dataLoading"
        :id="'dataBargraph'"
        :data="dataOption"
        style="height: 380px"
      ></linegraph>
      <div
        v-else
        style="
          color: #868686;
          font-size: 16px;
          text-align: center;
          line-height: 500px;
        "
      >
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import linegraph from "../../../../components/linegraph.vue";
// import * as echarts from "echarts";
// import iTable from "../../../../../src/components/Table.vue";
// import IPagination from "../../../../../src/components/pagination.vue";
import moment from "moment";
export default {
  props: ["bindTerminal"],
  components: {
    linegraph,
  },
  data() {
    return {
      selectType: 35,
      typeList: [],
      DataValue: [],
      dataLoading: false,
      dataOption: {},
      isValue: true,
      //   height: "350",
      //   list: [],
      //   option: {
      //     stripe: true,
      //     border: true,
      //     loading: false,
      //     highlightCurrentRow: false,
      //     mutiSelect: false,
      //     serialNumber: true,
      //   },
      //   columns: [
      //     {
      //       prop: "driverNum",
      //       label: this.$t("common.driverNum"),
      //       align: "center",
      //       width: "160",
      //     },
      //     {
      //       prop: "driverName",
      //       label: this.$t("common.driverName"),
      //       align: "center",
      //     },
      //     {
      //       prop: "workTime",
      //       label: this.$t("VehicleManagement.workHour"),
      //       align: "center",
      //     },
      //     {
      //       prop: "startTime",
      //       label: this.$t("VehicleManagement.openTime"),
      //       align: "center",
      //       width: "160",
      //     },
      //     {
      //       prop: "endTime",
      //       label: this.$t("VehicleManagement.closeTime"),
      //       align: "center",
      //       width: "160",
      //     },
      //   ],
      //   operates: {
      //     width: 100,
      //     fixed: "right",
      //     list: [],
      //   },
      //   currentPage: 1,
      //   pageSize: 10,
      //   total: 1,
      //   bindValue: "",
    };
  },
  mounted() {
    this.getCarType();
    this.getDate();
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      const startTime = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
      this.DataValue = [startTime, endTime];
    },
    getCarType() {
      this.$store
        .dispatch("DictionaryManaged/GET_SELECTCAROPERATIONTYPE", {})
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.typeList = res.data.data;
            }
          }
        })
        .catch((err) => {});
    },
    getRunningData() {
      this.dataLoading = true;
      let obj = {
        Data: [],
        power: [],
        dateType: "",
      };
      let param = {
        selectType: this.selectType,
        terminalId: this.bindTerminal,
        startTime: this.DataValue[0],
        endTime: this.DataValue[1],
      };
      this.$store
        .dispatch("VehicleStatus/GET_GETCAROPERATIONLIST", param)
        .then((res) => {
          if (res) {
            console.log(res);
            if (res.data.code == 200) {
              if (res.data.data.length > 0) {
                this.isValue = true;
                res.data.data.map((item, index) => {
                  obj.Data.push(item.messageTime);
                  obj.power.push(item.value);
                  obj.dateType = item.dateType;
                  this.RunningData(obj);
                });
              }else {
                this.isValue = false
              }
            }
          }
          this.dataLoading = false;
        })
        .catch((err) => {
          this.dataLoading = false;
        });
    },
    RunningData(obj) {
      let option = {
        legend: {
          data: [obj.dateType],
          left: "center",
          textStyle: {
            color: "#333",
          },
        },
        grid: {
          top: "15%",
          left: "3%",
          right: "3%",
          bottom: "10%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        dataZoom: [
          {
            type: "inside",
            textStyle: {
              color: "#333",
            },
          },
          {
            type: "slider",
            textStyle: {
              color: "#333",
            },
          },
        ],
        xAxis: {
          data: obj.Data,
          silent: false,
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#333",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#333",
            },
          },
          splitArea: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "value",
            name: obj.dateType,
            scale: true,
            nameTextStyle: {
              color: "#333",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["rgba(173,177,195,.3)"],
                type: "dashed",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}",
              color: "#333",
            },
          },
        ],
        series: [
          {
            name: obj.dateType,
            type: "line",
            data: obj.power,
            yAxisIndex: 0,
          },
        ],
      };
      this.dataOption = option;
    },
    onSearch() {
      //   this.$refs.page.CommandCurrentPage = 1;
      //   this.currentPage = 1;
      this.getRunningData();
    },
    onClear() {
      this.selectType = 35;
      this.getDate();
      this.getCarType();
      this.getRunningData();
    },
    // handleSelectionChange(val) {
    //   this.selected = val;
    // },
    // changeSize(item) {
    //   this.pageSize = item.pageSize;
    //   this.currentPage = item.pageNum;
    //   this.getCarRealTime();
    // },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
